import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { PhoneLandInput } from "../../../../components";
import InvoiceGroupInput from "./InvoiceGroupInput";

const PhoneNumberForInternetFttx = () => {
  const { setFieldValue }: any = useFormikContext();
  const { t } = useTranslation();

  return (
    <>
      <Grid item md={6}>
        <PhoneLandInput
          name={`phoneInternet`}
          label={t("land_phone")}
          handleChange={(e: any) => {
            setFieldValue(
              `phoneInternet`,
              e.target.value.replace(/\D/g, "") // removes all non-numeric characters
            );
          }}
        />
      </Grid>
      {/* <Grid item md={6}>
        <InvoiceGroupInput name="invoiceGroup" />
      </Grid> */}
    </>
  );
};

export default PhoneNumberForInternetFttx;
